import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { compose } from 'recompose';
import { withMixpanel } from '../../../../../components/Common/withMixpanel';
import goTo from '../../../../../actions/goTo';

const styles = theme => ({
    container: {
        backgroundColor: '#fff',
        width: 280,
        background: 'rgba(255, 255, 255, 1)',
        boxShadow: 'rgba(140, 140, 140, 0.2) 0px 0px 0px 1px',
        borderRadius: 12,
        marginTop: 10,
        wordBreak: 'break-word'
    },
    containerInner: {
        margin: 18
    },
    titleSection: {
        display: 'flex',
        height: 24,
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    divider: {
        height: 1,
        width: 'calc(100% + 36px)',
        marginTop: 12,
        marginRight: -18,
        marginLeft: -18,
        background: 'rgba(183, 184, 189, 0.15)',        
    },
    title: {
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '20px',
        letterSpacing: 'normal',
        color: '#18181B',
    },
    titleIcon: {
        color: '#21212d',
        display: 'flex',
        flexDirection: 'column',
        fontSize: 17,
        marginRight: 10
    },
    options: {
        marginTop: 24,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        listStyle: 'none',
        marginLeft: 0,
        paddingLeft: 0,
    },
    work: {
        marginBottom: 16,
        display: 'flex',
        justifyContent: 'flex-start',
    },
    groupInfoHolder: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        marginTop: 2,
    },
    titleWork: {
        fontFamily: 'Rubik',
        fontSize: 12,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '16px',
        letterSpacing: 0,
        color: '#18181B',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: 204,
        whiteSpace: 'nowrap',
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'underline'
        }
    },
    titleWorkChip: {
        fontFamily: 'Rubik',
        fontSize: 13,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '16px',
        letterSpacing: 0,
        color: '#18181B',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        maxWidth: 150,
        marginRight: 8,
        whiteSpace: 'nowrap',
        cursor: 'pointer',

        '&:hover': {
            textDecoration: 'underline'
        }
    },
    description: {
        fontFamily: 'Rubik',
        fontSize: 12,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '12px',
        letterSpacing: ' normal',
        color: '#6B6F7A',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: 204,
        whiteSpace: 'nowrap',
    },
    imageUser: {
        marginRight: 8,
        width: 32,
        height: 32,
        borderRadius: 8,
    },
    imageUserChip: {
        marginRight: 8,
        width: 24,
        height: 24,
        borderRadius: 12,
    },
    teamHeading: {
        fontFamily: 'Rubik',
        fontSize: 12,
        fontWeight: 400,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '16px',
        letterSpacing: 2,
        color: '#6B6F7A',
        marginBottom: 12,
        // textTransform: 'uppercase'
    },
    seeOrgChat: {
        textAlign: 'center',
        color: '#6B6F7A',
        fontSize: 14,
        lineHeight: '20px',
        marginLeft: 8,
        fontWeight: 500,
    },
    seeOrgChatBtn: {
        cursor: 'pointer',
        marginTop: 12,
        display: 'flex',
        alignItems: 'center',
    },
    teamItem: {
        height: 40,
        marginBottom: 16,
        display: 'flex',
        justifyContent: 'flex-start',
    },
    teamItemChip: {
        height: 24,
        marginRight: 8,
        marginTop: 8,
        display: 'flex',
        borderRadius: 9999,
        border: "1px solid rgba(183, 184, 189, 0.20)",
        alignItems: 'center',
        background: "rgba(183, 184, 189, 0.07)",
    },
    teammates: {
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -14,
    }
});

const TeammateComponent = ({ userData, classes, onTitleClick }) => {
    return (<div data-intrcm-id="UserTeamWidget_58n43m4k" className={classes.teamItem}>
        <img alt={userData.title} src={userData.profileImageUrl} className={classes.imageUser} />
        <div data-intrcm-id="UserTeamWidget_up2t6kky" className={classes.groupInfoHolder}>
            <span onClick={() => onTitleClick(userData.tag)} className={classes.titleWork}>{userData.firstname + ' ' + userData.lastname}</span>
            <span className={classes.description}>{userData.title}</span>
        </div>
    </div>)
}

const TeammateComponentChip = ({ userData, classes, onTitleClick }) => {
    return (<div data-intrcm-id="UserTeamWidget_58n43m4k" className={classes.teamItemChip}>
        <img alt={userData.title} src={userData.profileImageUrl} className={classes.imageUserChip} />
        <span onClick={() => onTitleClick(userData.tag)} className={classes.titleWorkChip}>{userData.firstname?.trim?.() ?? ""} {userData.lastname?.trim?.() ?? ""}</span>
    </div>)
}
const TeammateComponentChipMore = ({ classes, onTitleClick, title }) => {
    return (<div data-intrcm-id="UserTeamWidget_58n43m4k" style={{background: 'rgba(129, 140, 248, 0.10)'}} className={classes.teamItemChip}>
        <span style={{marginLeft: 8}} onClick={onTitleClick} className={classes.titleWorkChip}>{title}</span>
    </div>)
}

const OrgChatIcon = () => <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.47846 2.79999H10.8216C11.1177 2.79998 11.3732 2.79997 11.5847 2.8144C11.8073 2.82959 12.03 2.863 12.25 2.95413C12.7462 3.15966 13.1404 3.55387 13.3459 4.05005C13.437 4.27006 13.4704 4.49275 13.4856 4.71538C13.5001 4.92682 13.5001 5.18229 13.5 5.47837V5.47838V5.4784V5.52158V5.5216V5.52161C13.5001 5.81769 13.5001 6.07316 13.4856 6.2846C13.4704 6.50723 13.437 6.72992 13.3459 6.94992C13.1404 7.4461 12.7462 7.84032 12.25 8.04585C12.03 8.13697 11.8073 8.17039 11.5847 8.18558C11.3732 8.2 11.1177 8.2 10.8216 8.19999H5.17505V9.77499C5.17505 10.5181 5.17541 11.0416 5.20346 11.4526C5.23108 11.8575 5.2833 12.1036 5.36345 12.2971C5.61465 12.9036 6.09646 13.3854 6.70291 13.6366C6.89639 13.7167 7.14254 13.769 7.54746 13.7966C7.9173 13.8218 8.37827 13.8246 9.00837 13.825C9.01005 13.7872 9.01205 13.7507 9.01446 13.7154C9.02965 13.4927 9.06307 13.2701 9.15419 13.0501C9.35972 12.5539 9.75393 12.1597 10.2501 11.9541C10.4701 11.863 10.6928 11.8296 10.9154 11.8144C11.1269 11.8 11.3823 11.8 11.6784 11.8H11.6785H13.5216H13.5217C13.8178 11.8 14.0732 11.8 14.2847 11.8144C14.5073 11.8296 14.73 11.863 14.95 11.9541C15.4462 12.1597 15.8404 12.5539 16.0459 13.0501C16.137 13.2701 16.1704 13.4927 16.1856 13.7154C16.2001 13.9268 16.2001 14.1823 16.2 14.4784V14.4784V14.4784V14.5216V14.5216V14.5216C16.2001 14.8177 16.2001 15.0732 16.1856 15.2846C16.1704 15.5072 16.137 15.7299 16.0459 15.9499C15.8404 16.4461 15.4462 16.8403 14.95 17.0458C14.73 17.137 14.5073 17.1704 14.2847 17.1856C14.0732 17.2 13.8177 17.2 13.5217 17.2H13.5217H13.5216H11.6785H11.6784H11.6784C11.3824 17.2 11.1269 17.2 10.9154 17.1856C10.6928 17.1704 10.4701 17.137 10.2501 17.0458C9.75393 16.8403 9.35972 16.4461 9.15419 15.9499C9.06307 15.7299 9.02965 15.5072 9.01446 15.2846C9.01205 15.2493 9.01004 15.2127 9.00837 15.175C8.38407 15.1747 7.87557 15.1721 7.45556 15.1435C6.9819 15.1111 6.57168 15.0435 6.18629 14.8838C5.24905 14.4956 4.50442 13.751 4.11621 12.8138C3.95657 12.4284 3.8889 12.0181 3.85659 11.5445C3.82504 11.0821 3.82504 10.5126 3.82505 9.79934L3.82505 8.19167C3.7873 8.18999 3.75075 8.18799 3.71544 8.18558C3.49281 8.17039 3.27012 8.13697 3.05012 8.04585C2.55393 7.84032 2.15972 7.4461 1.95419 6.94992C1.86307 6.72992 1.82965 6.50723 1.81446 6.2846C1.80003 6.07315 1.80004 5.81767 1.80005 5.52158V5.52158V5.4784V5.4784C1.80004 5.18231 1.80003 4.92683 1.81446 4.71538C1.82965 4.49275 1.86307 4.27006 1.95419 4.05005C2.15972 3.55387 2.55393 3.15966 3.05012 2.95413C3.27012 2.863 3.49281 2.82959 3.71544 2.8144C3.92689 2.79997 4.18237 2.79998 4.47846 2.79999H4.47846ZM3.80734 4.16127C3.65344 4.17177 3.59483 4.18973 3.56674 4.20137C3.40134 4.26988 3.26994 4.40128 3.20143 4.56668C3.1898 4.59477 3.17183 4.65338 3.16133 4.80728C3.15042 4.96724 3.15005 5.17624 3.15005 5.49999C3.15005 5.82373 3.15042 6.03274 3.16133 6.1927C3.17183 6.3466 3.1898 6.40521 3.20143 6.4333C3.26994 6.59869 3.40134 6.7301 3.56674 6.79861C3.59483 6.81024 3.65344 6.82821 3.80734 6.83871C3.9673 6.84962 4.1763 6.84999 4.50005 6.84999H10.8C11.1238 6.84999 11.3328 6.84962 11.4928 6.83871C11.6467 6.82821 11.7053 6.81024 11.7334 6.79861C11.8988 6.7301 12.0302 6.59869 12.0987 6.4333C12.1103 6.40521 12.1283 6.3466 12.1388 6.1927C12.1497 6.03274 12.15 5.82373 12.15 5.49999C12.15 5.17624 12.1497 4.96724 12.1388 4.80728C12.1283 4.65338 12.1103 4.59477 12.0987 4.56668C12.0302 4.40128 11.8988 4.26988 11.7334 4.20137C11.7053 4.18973 11.6467 4.17177 11.4928 4.16127C11.3328 4.15035 11.1238 4.14999 10.8 4.14999H4.50005C4.1763 4.14999 3.9673 4.15035 3.80734 4.16127ZM11.0073 13.1613C10.8534 13.1718 10.7948 13.1897 10.7667 13.2014C10.6013 13.2699 10.4699 13.4013 10.4014 13.5667C10.3898 13.5948 10.3718 13.6534 10.3613 13.8073C10.3504 13.9672 10.35 14.1762 10.35 14.5C10.35 14.8237 10.3504 15.0327 10.3613 15.1927C10.3718 15.3466 10.3898 15.4052 10.4014 15.4333C10.4699 15.5987 10.6013 15.7301 10.7667 15.7986C10.7948 15.8102 10.8534 15.8282 11.0073 15.8387C11.1673 15.8496 11.3763 15.85 11.7 15.85H13.5C13.8238 15.85 14.0328 15.8496 14.1928 15.8387C14.3467 15.8282 14.4053 15.8102 14.4334 15.7986C14.5988 15.7301 14.7302 15.5987 14.7987 15.4333C14.8103 15.4052 14.8283 15.3466 14.8388 15.1927C14.8497 15.0327 14.85 14.8237 14.85 14.5C14.85 14.1762 14.8497 13.9672 14.8388 13.8073C14.8283 13.6534 14.8103 13.5948 14.7987 13.5667C14.7302 13.4013 14.5988 13.2699 14.4334 13.2014C14.4053 13.1897 14.3467 13.1718 14.1928 13.1613C14.0328 13.1504 13.8238 13.15 13.5 13.15H11.7C11.3763 13.15 11.1673 13.1504 11.0073 13.1613Z" fill="#6B6F7A"/>
</svg>


const UserTeamWidget = (props) => {
    const { classes, dispatch, isMyUser, userProfile, activeUsers, mixpanelTrack, withoutContainer } = props;
    const [supervisor, setSupervisor] = useState({ profile: null, exists: false })
    const [teammates, setTeammates] = useState({ data: [], exists: false })
    const { t } = useTranslation('userTeamWidget')
    const { firstname, id, superiorId } = userProfile

    useEffect(() => {
        const supervisor = activeUsers.find(u => u.id === superiorId)
        const childs = activeUsers.filter(u => u.superiorId === superiorId && u.id !== id)

        if (!!supervisor) setSupervisor({ exists: true, profile: supervisor })
        if (!!childs) setTeammates({ exists: true, data: childs.sort((a, b) => b.points - a.points) })
    }, [superiorId.id, activeUsers])

    const openUser = (tag) => {
        let userTagFormat = ''
        if (!tag.startsWith('@')) {
            userTagFormat = `@`
        }
        mixpanelTrack('User team widget - open user', {})
        userTagFormat += tag.replace(' ', '').toLowerCase()
        goTo(userTagFormat, dispatch)()
    }

    const goToChart = () => {
        mixpanelTrack('User team widget - go to org chart', {})
        dispatch(push('/orgchart'))
    }
    const Content = (
            <>
                <div data-intrcm-id="UserTeamWidget_mxjqed97" className={classes.titleSection}>
                    <div data-intrcm-id="UserTeamWidget_wlk3qwui" className={classes.title}>{isMyUser ? t("My Team") : t("{{userName}}'s Team", {userName: firstname})}</div>
                </div>
                <div className={classes.divider}/>
                <div data-intrcm-id="UserTeamWidget_wtk8gi8d" className={classes.teamHolder}>
                    {supervisor.exists && <>
                        <h4 className={classes.teamHeading}>{t("Supervisor")}</h4>
                        <TeammateComponent onTitleClick={openUser} classes={classes} userData={supervisor.profile} />
                        <div className={classes.divider}/>
                    </>
                    }
                    <h4 className={classes.teamHeading}>{t("Teammates")}</h4>
                    {teammates.exists && <>
                    <div className={classes.teammates}>
                    {teammates.data.slice(0, 3).map(item => {
                        return <TeammateComponentChip key={item.id} onTitleClick={openUser} classes={classes} userData={item} />
                    })}
                    {teammates.data.length > 3 && <TeammateComponentChipMore onTitleClick={goToChart} classes={classes} title={t("More")} />}
                    </div>
                    <div className={classes.divider}/>
                    </>}
                    <div className={classes.seeOrgChatBtn} onClick={goToChart}>
                        <OrgChatIcon />
                        <div data-intrcm-id="UserTeamWidget_0wpyfp5z" className={classes.seeOrgChat}>{t("Go To Org Chart")}</div>
                    </div>
                </div>
            </>
    )
    if(!!withoutContainer) return Content
    return (
        <Grid container direction='column' className={classes.container}>
            <div data-intrcm-id="UserTeamWidget_6yrbbcbv" className={classes.containerInner}>
                {Content}
            </div>
        </Grid>
    )
}

const mapStateToProps = (state) => ({
    activeUsers: state.globalData.activeUsers
})

const mapDispatchToProps = (dispatch) => ({
    dispatch
})

export default compose(
    withStyles(styles),
    withTranslation('userTeamWidget'),
    withMixpanel,
    connect(mapStateToProps, mapDispatchToProps),
)(UserTeamWidget);